import React from 'react';
import InputSwitch from "../../../../components/input/input-switch.jsx";

const IntegrationCellRenderer = ({data, integration, api, verifyIfAllOptionsIsOn}) => {
    const onChange = (checked) => {
        const status = checked ? "ON" : "OFF";

        const rowNode = api.getRowNode(data.code);
        rowNode.setData({
            ...rowNode.data,
            [integration] : {status}
        });

        verifyIfAllOptionsIsOn(api, integration);
    }

    return (
        <div className={"h-full w-full justify-items-center report-center text-center"}>
            {(data[integration]?.status === undefined || data[integration]?.status === "ND") && "ND"}

            {
                (data[integration]?.status !== undefined && data[integration]?.status !== "ND") &&
                <InputSwitch
                    checked={data[integration]?.status === "ON"}
                    onChange={(e) => onChange(e, data, integration)}
                />
            }
        </div>
    );
};

export default IntegrationCellRenderer;